import styled from 'styled-components';
import WheelChairSvg from '../../assets/amenities/wheel-chiar.svg';

const WheelChairIcon = styled(WheelChairSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default WheelChairIcon;
